export default __webpack_public_path__ + "static/media/icon_radio_button_unchecked.8b06ae3a.svg";